// extracted by mini-css-extract-plugin
export default {"main-content":"BckZVtvhdbDKmbc6XU6F"};